/**
 * Toggles .product-price--wrapped when inline price drops below the variant row.
 */
(function () {
  const OPTIONS_SELECTOR = '.product-options--inline-price';
  const PRICE_SELECTOR = '.product-price--after-variant-picker';
  const WRAPPED_CLASS = 'product-price--wrapped';
  const WRAP_TOLERANCE = 2;

  function getPriceAfterOptions(options) {
    const next = options.nextElementSibling;
    return next?.matches(PRICE_SELECTOR) ? next : null;
  }

  function updatePair(options, price) {
    if (!options || !price) return;
    const anchor = options.querySelector('.option-selector__btns') || options;
    const wrapped =
      price.getBoundingClientRect().top >= anchor.getBoundingClientRect().bottom - WRAP_TOLERANCE;
    price.classList.toggle(WRAPPED_CLASS, wrapped);
  }

  function scan(root = document) {
    root.querySelectorAll(OPTIONS_SELECTOR).forEach((options) => {
      updatePair(options, getPriceAfterOptions(options));
    });
  }

  function init() {
    scan();

    document.addEventListener('on:variant:change', () => scan());

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', () => scan(), { passive: true });
      return;
    }

    const observer = new ResizeObserver(() => scan());
    document.querySelectorAll('.product-info, .product-info__block').forEach((el) => observer.observe(el));
    window.addEventListener('resize', () => scan(), { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
